import { Component, Input } from '@angular/core';
import {
  builderCategories,
  createChartData,
  provideChartData,
  orphandResourceCategories,
  unusedResourceCategories,
} from 'src/app/common/chartUtils';
import {
  AggregationDict,
  AggregationsModel,
  buildersAdoptionData,
  orphanResourcesData,
  toTopBuilder,
  topBuilders,
  totalResourcesData,
  unusedResourcesData,
} from 'src/app/models/api/aggregations.model';
import { AggregationCategorySumDetails, AggregationTrendSeries, IChartData } from 'src/app/models/api/dashboards.model';
import { ResourceCategory } from 'src/app/models/api/inventoryResource.model';
import { ISelectedFilters } from 'src/app/models/filters/selectedFilters.interface';
import { BeautifyDisplayStringPipe } from 'src/app/pipes/beautify-display-string/beautify-display-string.pipe';

@Component({
  selector: 'app-visibility-dashboard-content',
  templateUrl: './visibility-dashboard-content.component.html',
  styleUrls: ['./visibility-dashboard-content.component.scss'],
})
export class VisibilityDashboardContentComponent {
  constructor(private readonly _beautifyDisplayStringPipe: BeautifyDisplayStringPipe) {}

  private _aggregations: AggregationsModel | null;

  @Input() public selectedFilters: ISelectedFilters;
  @Input() public set aggregationsModel(model: AggregationsModel | null) {
    if (model == this._aggregations) return;

    if (model != null) {
      this.totalResourcesOfCategoryData = totalResourcesData(model);
      this.topBuilders = topBuilders(model).map(toTopBuilder);
      this.unusedResources = createChartData(unusedResourcesData(model), unusedResourceCategories);
      this.orphanResources = createChartData(orphanResourcesData(model), orphandResourceCategories);
      this.buildersAdoption = provideChartData(
        buildersAdoptionData(model),
        builderCategories,
        'Builders',
        this._beautifyDisplayStringPipe
      );
    }

    this._aggregations = model;
  }

  public get aggregationsModel() {
    return this._aggregations;
  }

  public totalResourcesOfCategoryData: AggregationDict;
  public automationResourceCategory = ResourceCategory.automation;
  public applicationResourceCategory = ResourceCategory.application;
  public connectionResourceCategory = ResourceCategory.connection;
  public environmentResourceCategory = ResourceCategory.environment;
  public dataStorageResourceCategory = ResourceCategory.dataStorage;
  public botResourceCategory = ResourceCategory.bot;

  public topBuilders: AggregationCategorySumDetails[];
  public unusedResources: IChartData[];
  public orphanResources: IChartData[];
  public buildersAdoption: AggregationTrendSeries[];
}
